export default __webpack_public_path__ + "static/media/geminon_text.a4627a85.png";